<app-settings-navbar></app-settings-navbar>
<app-breadcrumb style="display: flex; padding-left: 28px"></app-breadcrumb>

<div class="content">
  <router-outlet></router-outlet>
</div>
